import { useCallback, useEffect, useRef } from 'react';

import { Loader } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';

const options = {
  root: null,
  rootMargin: '0px'
};

const InfiniteScroll = ({ children, isLoadedAllResults, handleLoadMore, threshold }) => {
  const observerRef = useRef(null);

  // Use a flag to prevent multiple calls
  const isLoadingRef = useRef(false);

  const handleIntersection = useCallback(
    entries => {
      const entry = entries[0];
      if (entry.isIntersecting && !isLoadingRef.current) {
        isLoadingRef.current = true;
        try {
          handleLoadMore();
        } finally {
          isLoadingRef.current = false;
        }
      }
    },
    [handleLoadMore]
  );

  // Set up IntersectionObserver when component mounts
  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection, {
      ...options,
      threshold
    });

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => {
      if (observerRef.current) {
        observer.unobserve(observerRef.current);
      }
    };
  }, [isLoadedAllResults]);

  return (
    <div className="infinite-scroll-container">
      {children}

      {!isLoadedAllResults && (
        <div ref={observerRef}>
          <Loader isInlineLoader />
        </div>
      )}
    </div>
  );
};

InfiniteScroll.propTypes = {
  children: PropTypes.node.isRequired,
  isLoadedAllResults: PropTypes.bool.isRequired,
  handleLoadMore: PropTypes.func.isRequired,
  threshold: PropTypes.number
};

InfiniteScroll.defaultProps = {
  threshold: 1.0
};

export default InfiniteScroll;
